import { useCallback } from 'react';
import { useSnackbar, VariantType } from 'notistack';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

type EnqueueOptions = {
  variant?: VariantType;
  autoHideDuration?: number;
  anchorOrigin?: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
};

export function useTranslatedSnackbar() {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const enqueueTranslated = useCallback(
    (messageKey: string, options?: EnqueueOptions) =>
      enqueueSnackbar(String(t(messageKey)), options),
    [enqueueSnackbar, t],
  );

  return { enqueueTranslated };
}
